import Meta from '@/components/common/Meta'
import { META_CONTENTS } from '@/v1/constants/seo'
import NewsAndPressPage from '@/v2/components/pages/public-pages/news-and-press-page'
import { metaImages, ogImages } from '@/v2/constants/pages/public-pages/news-and-press-page'

interface NewsAndPressPageProps {}

const Page: React.FC<NewsAndPressPageProps> = () => {
  return (
    <>
      <Meta
        title={META_CONTENTS.news_and_press.title ?? ''}
        keywords={META_CONTENTS.news_and_press?.keywords ?? ''}
        description={META_CONTENTS.news_and_press?.description ?? ''}
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <NewsAndPressPage />
    </>
  )
}

export default Page
